import { AndroidHealthConnectExerciseType, AppleHKWorkoutActivityType } from 'fitbeat.models';
import { ActivityType } from '../exercise';

type FitillionWorkoutActivityTypeMapping = Map<ActivityType, number>;

// see https://docs.google.com/spreadsheets/d/1F_4NPreP8QOs_b82mWyDvkI66lV4ti6rdcMtnUAZkqg

export const AppleHKWorkoutActivityTypeMapping = new Map<ActivityType, number>([
  [ActivityType.BurnFitillion, AppleHKWorkoutActivityType.highIntensityIntervalTraining],
  [ActivityType.BuildFitillion, AppleHKWorkoutActivityType.functionalStrengthTraining],
  [ActivityType.BalanceFitillion, AppleHKWorkoutActivityType.pilates],
  [ActivityType.BoxingFitillion, AppleHKWorkoutActivityType.kickboxing],
  [ActivityType.Stepper, AppleHKWorkoutActivityType.stepTraining],
  [ActivityType.Elliptical, AppleHKWorkoutActivityType.elliptical],
  [ActivityType.TreadmillFitillion, AppleHKWorkoutActivityType.running],
  [ActivityType.StudioBikeFitillion, AppleHKWorkoutActivityType.cycling],
  [ActivityType.PowerStationFitillion, AppleHKWorkoutActivityType.traditionalStrengthTraining],
  [ActivityType.RowingAndPaddling, AppleHKWorkoutActivityType.rowing],
]);

export const AndroidHealthConnectExerciseTypeMapping = new Map<ActivityType, number>([
  [ActivityType.BurnFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_HIGH_INTENSITY_INTERVAL_TRAINING],
  [ActivityType.BuildFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_STRENGTH_TRAINING],
  [ActivityType.BalanceFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_PILATES],
  [ActivityType.BoxingFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_BOXING],
  [ActivityType.Stepper, AndroidHealthConnectExerciseType.EXERCISE_TYPE_STAIR_CLIMBING_MACHINE],
  [ActivityType.Elliptical, AndroidHealthConnectExerciseType.EXERCISE_TYPE_ELLIPTICAL],
  [ActivityType.TreadmillFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_RUNNING_TREADMILL],
  [ActivityType.StudioBikeFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_BIKING_STATIONARY],
  [ActivityType.PowerStationFitillion, AndroidHealthConnectExerciseType.EXERCISE_TYPE_STRENGTH_TRAINING],
  [ActivityType.RowingAndPaddling, AndroidHealthConnectExerciseType.EXERCISE_TYPE_ROWING_MACHINE],
]);

export function getMappedWorkoutActivityType(
  activityType: ActivityType,
  workoutMapping: FitillionWorkoutActivityTypeMapping,
  notify: (s: Error) => void,
) {
  const mappedActivityType = workoutMapping.get(activityType);
  if (mappedActivityType === undefined) {
    notify(new Error(`Unknown activity type: ${activityType}, defaulting to 'other'`));
    return AppleHKWorkoutActivityType.other;
  }
  return mappedActivityType;
}
